import React from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaArrowRight,
} from 'react-icons/fa';

const Footer = () => {
  const quickLinks = [
    { label: 'Accueil', href: '#accueil' },
    { label: 'À propos', href: '#apropos' },
    { label: 'Nos services', href: '#services' },
    { label: 'Nos solutions', href: '#zwacop' },
    { label: 'Nos projets', href: '#projets' },
    { label: 'Nos secteurs', href: '#secteurs' },
    { label: 'Contact', href: '#contact' },
  ];

  const services = [
    'Informatique & solutions numériques',
    'Applications web & mobiles',
    'Ingénierie & IBTP',
    'Solutions de gestion & traçabilité',
    'Agriculture & technologies agricoles',
    'Sous-traitance & services professionnels',
  ];

  const solutions = [
    'ZWACOP — Mise en relation',
    'EDEN Manager — Gestion',
    'Solutions de tracking',
    'Plateformes numériques',
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-col footer-about">
            <a href="#accueil" className="footer-logo">
              <img
                src="/images/dark-mode-logo.png"
                alt="Livia Tech"
                className="footer-logo-img"
              />
              <div className="logo-text">
                <span className="logo-name">Livia Tech</span>
                <span className="logo-tagline">Solutions & Innovations</span>
              </div>
            </a>
            <p>
              Entreprise congolaise de développement social, technologique et économique.
              Nous concevons des solutions adaptées aux réalités africaines, combinant
              technologie, ingénierie et expertise professionnelle pour transformer les
              secteurs d'activité et créer des opportunités.
            </p>
            <div className="footer-socials">
              <a href="https://www.facebook.com/share/1Jb6PtxQXt/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="footer-social" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://instagram.com/liviatech" target="_blank" rel="noopener noreferrer" className="footer-social" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://linkedin.com/company/liviatech" target="_blank" rel="noopener noreferrer" className="footer-social" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>
              <a href="https://wa.me/243838249020" target="_blank" rel="noopener noreferrer" className="footer-social" aria-label="WhatsApp">
                <FaWhatsapp />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Liens rapides</h4>
            <ul className="footer-links">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href}>
                    <FaArrowRight className="footer-link-icon" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Nos services</h4>
            <ul className="footer-links">
              {services.map((service, index) => (
                <li key={index}>
                  <a href="#services">
                    <FaArrowRight className="footer-link-icon" />
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Nos solutions</h4>
            <ul className="footer-links">
              {solutions.map((solution, index) => (
                <li key={index}>
                  <a href="#zwacop">
                    <FaArrowRight className="footer-link-icon" />
                    {solution}
                  </a>
                </li>
              ))}
            </ul>
            <h4 className="footer-contact-title">Coordonnées</h4>
            <div className="footer-contact">
              <a href="tel:+243838249020" className="footer-contact-item">
                <FaPhone className="footer-contact-icon" />
                +243 838 249 020
              </a>
              <a href="mailto:jb@liviatech.store" className="footer-contact-item">
                <FaEnvelope className="footer-contact-icon" />
                jb@liviatech.store
              </a>
              <span className="footer-contact-item">
                <FaMapMarkerAlt className="footer-contact-icon" />
                République Démocratique du Congo
              </span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Livia Tech. Tous droits réservés.</p>
          <p className="footer-made">
            Conçu et développé avec passion en République Démocratique du Congo.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;